// extracted by mini-css-extract-plugin
export default {"idContainer":"styles_idContainer__FJAEt","ref-copy-button":"styles_ref-copy-button__94B+V"};